export const publicUrls = ["/form-submission/","/formlink-submission/"];
export const supportedPaymentCountry = ["INR", "USD"];
export const defaultCurrency = "USD";
export const templatesPerPage = 9;
